var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card bs-4 bgc-primary"},[_vm._v(" Closing Session... ")])}
var staticRenderFns = []

export { render, staticRenderFns }